module.exports = __webpack_public_path__ + "img/img22.4dd31fe7.png";